// import { useState, useEffect, useRef } from "react";
// import { Modal } from "../../ui/modal";
// import Alert from "../../ui/alert/Alert";
// import { Wallet } from "../types";
// import { X, Loader2, CheckCircle, Phone, ChevronDown, Wifi } from "lucide-react";
// import axios from "axios";
// import { cache } from "../../../utils";
// import { User as UserType } from "../../../stores/useUserStore";
// import EnterPinModal from "../../ui/modal/EnterPinModal";
// import Spinner from "../../ui/Spinner/Spinner";
// import Toast from "../../ui/toast/Toast";
// import { autoClearError } from "../../../utils/helpers";

// interface MobileMoneyWithdrawModalProps {
//   isOpen: boolean;
//   onClose: () => void;
//   onSuccess: () => void;
//   wallet: Wallet;
//   amount: number;
//   fee: number;
//   preloadedNetworks?: any[];
// }

// const MobileMoneyWithdrawModal = ({
//   isOpen,
//   onClose,
//   wallet,
//   amount,
//   fee,
//   onSuccess,
//   preloadedNetworks = [],
// }: MobileMoneyWithdrawModalProps) => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [networks, setNetworks] = useState<any[]>(preloadedNetworks);
//   const [showPinModal, setShowPinModal] = useState(false);
  
//   const [selectedNetwork, setSelectedNetwork] = useState<any>(null);
//   const [isNetworkDropdownOpen, setIsNetworkDropdownOpen] = useState(false);
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [narration, setNarration] = useState("");
//   const [isVerifyingPhone, setIsVerifyingPhone] = useState(false);
//   const [phoneVerified, setPhoneVerified] = useState(false);
  
//   const networkDropdownRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     if (isOpen) {
//       resetForm();
//       // If we have preloaded networks, use them
//       if (preloadedNetworks.length > 0) {
//         setNetworks(preloadedNetworks);
//       }
//     }
//   }, [isOpen, preloadedNetworks]);

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (networkDropdownRef.current && !networkDropdownRef.current.contains(event.target as Node)) {
//         setIsNetworkDropdownOpen(false);
//       }
//     };
    
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Phone verification with debounce
//   useEffect(() => {
//     if (selectedNetwork && phoneNumber.length === 9 && !phoneVerified && !isVerifyingPhone) {
//       const debounceTimer = setTimeout(() => {
//         verifyPhoneNumber();
//       }, 1000);

//       return () => clearTimeout(debounceTimer);
//     }
//   }, [selectedNetwork, phoneNumber]);

//   const resetForm = () => {
//     setSelectedNetwork(null);
//     setPhoneNumber("");
//     setNarration("");
//     setError("");
//     setSuccess("");
//     setPhoneVerified(false);
//     setIsNetworkDropdownOpen(false);
//   };

//   const handleNetworkSelect = (network: any) => {
//     setSelectedNetwork(network);
//     setIsNetworkDropdownOpen(false);
//     setPhoneVerified(false);
//     setPhoneNumber("");
//     setError("");
//   };

//   const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const value = e.target.value.replace(/\D/g, "");
//     const limitedValue = value.slice(0, 9);
    
//     setPhoneNumber(limitedValue);
    
//     // Clear verified status when phone number changes
//     if (phoneVerified && limitedValue !== phoneNumber) {
//       setPhoneVerified(false);
//     }
//   };

//   const verifyPhoneNumber = async () => {
//     if (!selectedNetwork || !phoneNumber) return;

//     setIsVerifyingPhone(true);
//     setError("");

//     try {

//       if (phoneNumber.length === 9) {
//         setPhoneVerified(true);
//       }
//     } catch (error: any) {
//       setError("Failed to verify phone number");
//     } finally {
//       setIsVerifyingPhone(false);
//     }
//   };

//   const validateForm = () => {
//     if (!selectedNetwork) {
//       setError("Please select a mobile network");
//       autoClearError(setError);
//       return false;
//     }
    
//     if (!phoneNumber || phoneNumber.length !== 9) {
//       setError("Please enter a valid 9-digit phone number");
//       autoClearError(setError);
//       return false;
//     }
    
//     if (!phoneVerified) {
//       setError("Please verify the phone number");
//       autoClearError(setError);
//       return false;
//     }
    
//     return true;
//   };

//   const handleContinue = () => {
//     if (!validateForm()) return;
//     setShowPinModal(true);
//   };

//   const handlePinVerification = async (pin: string): Promise<boolean> => {
//     try {
//       const user = cache.get("USER") as UserType | null;
//       const token = user?.token;
      
//       const validationResponse = await axios.post(
//         `${import.meta.env.VITE_BASE_URL}/user/pin/validate`,
//         { pin },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (validationResponse.data?.success) {
//         // PIN is valid, proceed with withdrawal
//         await processMobileMoneyWithdrawal();
//         return true;
//       } else {
//         setError("Invalid PIN. Please try again.");
//         autoClearError(setError);
//         return false;
//       }
//     } catch (error: any) {
//       setError(error.response?.data?.message || "Failed to verify PIN");
//       autoClearError(setError);
//       return false;
//     }
//   };

//   const processMobileMoneyWithdrawal = async () => {
//     setLoading(true);
//     setError("");
//     setSuccess("");

//     try {
//       const user = cache.get("USER") as UserType | null;
//       const token = user?.token;

//       const idempotencyKey = `WITHDRAWAL::MOBILEMONEY::${wallet.name}-${amount}-${phoneNumber}`;
      
//       // Format phone number with country code
//       const fullPhoneNumber = phoneNumber.startsWith("233")
//         ? phoneNumber
//         : `233${phoneNumber}`;
      
//       const response = await axios.post(
//         `${import.meta.env.VITE_BASE_URL}/transaction/transfer/momo`,
//         {
//           currency: wallet.currency,
//           amount: amount,
//           narration: narration || `Withdrawal to ${selectedNetwork.name}`,
//           phoneNumber: fullPhoneNumber,
//           network: selectedNetwork.name,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "idempotencykey": idempotencyKey,
//           },
//         }
//       );

//       if (response.data?.success) {
//         setSuccess("Withdrawal successful! Money will be sent to your mobile money account.");
//         setShowPinModal(false);
//         setTimeout(() => {
//           onSuccess();
//         }, 3000);
//       } else {
//         throw new Error(response.data?.message || "Withdrawal failed");
//       }
//     } catch (err: any) {
//       setError(err.response?.data?.message || "Failed to process withdrawal");
//       setSuccess("");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatPhoneNumber = (phone: string): string => {
//     if (phone.length <= 3) return phone;
//     if (phone.length <= 6) return `${phone.slice(0, 3)} ${phone.slice(3)}`;
//     return `${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6)}`;
//   };

//   return (
//     <>
//       <Modal
//         isOpen={isOpen}
//         onClose={onClose}
//         className="max-w-md rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-gray-900"
//       >
//         <div className="mb-6">
//           <div className="flex items-center justify-between">
//             <button
//               onClick={onClose}
//               className="rounded-lg p-1 hover:bg-gray-100 dark:hover:bg-gray-800"
//               disabled={loading}
//             >
//               <X className="h-5 w-5 text-gray-500 dark:text-gray-400" />
//             </button>
//           </div>

//           {success && (
//             <div className="mb-4">
//               <Toast
//                 variant="success"
//                 title={success}
//                 message="Your account has been debited"
//               />
//             </div>
//           )}
          
//           <div className="mt-4 rounded-lg bg-gray-50 p-4 dark:bg-gray-800">
//             <div className="text-sm text-gray-500 dark:text-gray-400">
//               <p>Mobile Money Withdrawal to Ghana</p>
//             </div>
//             <div className="text-2xl font-bold text-gray-900 dark:text-white">
//               {wallet.symbol} {amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
//             </div>
//             <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">
//               Fee: {wallet.symbol} {fee.toFixed(2)}
//             </div>
//           </div>
//         </div>

//         {error && !showPinModal && (
//           <div className="mb-4">
//             <Alert variant="error" title="Error" message={error} />
//           </div>
//         )}

//         <div className="space-y-6">
//           {/* Network Provider Selection */}
//           <div className="relative" ref={networkDropdownRef}>
//             <label className="mb-2 flex items-center gap-1 text-sm font-medium text-gray-700 dark:text-gray-300">
//               <Wifi className="h-4 w-4" />
//               Mobile Network Provider
//             </label>
            
//             <div className="relative">
//               <button
//                 type="button"
//                 onClick={() => setIsNetworkDropdownOpen(!isNetworkDropdownOpen)}
//                 disabled={loading}
//                 className={`flex w-full items-center justify-between rounded-lg border px-4 py-3 text-left transition-colors ${
//                   selectedNetwork
//                     ? "border-primary bg-primary/5 dark:border-primary dark:bg-primary/10"
//                     : "border-gray-200 bg-gray-50 hover:border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:hover:border-gray-600"
//                 }`}
//               >
//                 <div className="flex items-center gap-3">
//                   {selectedNetwork ? (
//                     <>
//                       {selectedNetwork.logo && (
//                         <img
//                           src={selectedNetwork.logo}
//                           alt={selectedNetwork.name}
//                           className="h-6 w-6 object-contain"
//                         />
//                       )}
//                       <span className="font-medium text-gray-900 dark:text-white">
//                         {selectedNetwork.name}
//                       </span>
//                     </>
//                   ) : (
//                     <span className="text-gray-500 dark:text-gray-400">
//                       Select a mobile network
//                     </span>
//                   )}
//                 </div>
//                 <ChevronDown
//                   className={`h-5 w-5 text-gray-400 transition-transform ${
//                     isNetworkDropdownOpen ? "rotate-180" : ""
//                   }`}
//                 />
//               </button>

//               {isNetworkDropdownOpen && networks.length > 0 && (
//                 <div className="absolute z-10 mt-1 w-full rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800">
//                   <div className="max-h-60 overflow-auto py-1">
//                     {networks.map((network) => (
//                       <button
//                         key={network.code}
//                         type="button"
//                         onClick={() => handleNetworkSelect(network)}
//                         className={`flex w-full items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-700 ${
//                           selectedNetwork?.code === network.code
//                             ? "bg-gray-100 dark:bg-gray-700"
//                             : ""
//                         }`}
//                       >
//                         {network.logo && (
//                           <img
//                             src={network.logo}
//                             alt={network.name}
//                             className="h-5 w-5 object-contain"
//                           />
//                         )}
//                         <span className="font-medium text-gray-900 dark:text-white">
//                           {network.name}
//                         </span>
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
            
//             {selectedNetwork && (
//               <div className="mt-2 flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
//                 <Wifi className="h-3 w-3" />
//                 <span>Selected network: {selectedNetwork.name}</span>
//               </div>
//             )}
//           </div>

//           {/* Phone Number */}
//           <div>
//             <label className="mb-2 flex items-center gap-1 text-sm font-medium text-gray-700 dark:text-gray-300">
//               <Phone className="h-4 w-4" />
//               Mobile Money Number
//             </label>
//             <div className="relative">
//               <div className="absolute left-3 top-1/2 flex -translate-y-1/2 items-center">
//                 <span className="text-gray-500 dark:text-gray-400">+233</span>
//               </div>
//               <input
//                 type="tel"
//                 value={phoneNumber}
//                 onChange={handlePhoneChange}
//                 className="w-full rounded-lg border border-gray-200 bg-gray-50 pl-16 pr-10 py-3 text-gray-700 transition-colors focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white disabled:opacity-50"
//                 placeholder="Enter 9-digit number"
//                 disabled={loading || !selectedNetwork}
//                 maxLength={9}
//                 inputMode="numeric"
//                 pattern="[0-9]*"
//               />
              
//               <div className="absolute right-3 top-1/2 -translate-y-1/2">
//                 {isVerifyingPhone ? (
//                   <Spinner className="h-4 w-4 text-primary" />
//                 ) : phoneVerified ? (
//                   <CheckCircle className="h-4 w-4 text-green-500" />
//                 ) : null}
//               </div>
//             </div>
            
//             <div className="mt-2 flex flex-col gap-1">
//               <div className="text-xs text-gray-500 dark:text-gray-400">
//                 Enter your 9-digit number (without +233 prefix)
//               </div>
//               {phoneNumber && (
//                 <div className="text-xs font-medium text-gray-700 dark:text-gray-300">
//                   Complete number: +233 {formatPhoneNumber(phoneNumber)}
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Narration */}
//           <div>
//             <label className="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
//               Narration (Optional)
//             </label>
//             <input
//               type="text"
//               value={narration}
//               onChange={(e) => setNarration(e.target.value)}
//               className="w-full rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-gray-700 transition-colors focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white disabled:opacity-50"
//               placeholder="e.g., Withdrawal for personal use"
//               maxLength={100}
//               disabled={loading}
//             />
//             <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
//               {narration.length}/100 characters
//             </div>
//           </div>
//         </div>

//         <div className="mt-8 flex justify-end gap-3">
//           <button
//             onClick={onClose}
//             disabled={loading}
//             className="rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-100 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700"
//           >
//             Cancel
//           </button>
          
//           <button
//             onClick={handleContinue}
//             disabled={loading || !selectedNetwork || !phoneNumber || phoneNumber.length !== 9}
//             className="rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-100 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700"
//           >
//             {loading ? (
//               <>
//                 <Loader2 className="h-2 w-2 animate-spin" />
//               </>
//             ) : (
//               "Continue"
//             )}
//           </button>
//         </div>
//       </Modal>

//       {/* Separate PIN Modal */}
//       <EnterPinModal
//         isOpen={showPinModal}
//         onClose={() => setShowPinModal(false)}
//         onPinVerified={handlePinVerification}
//         title="Confirm Mobile Money Withdrawal"
//         description="Enter your 4-digit PIN to complete this withdrawal"
//         showForgotPin={true}
//       />
//     </>
//   );
// };

// export default MobileMoneyWithdrawModal;







import { useState, useEffect, useRef } from "react";
import { Modal } from "../../ui/modal";
import Alert from "../../ui/alert/Alert";
import { Wallet, Transaction } from "../types";
import { X, CheckCircle, Phone, ChevronDown, Wifi } from "lucide-react";
import axios from "axios";
import { cache } from "../../../utils";
import { User as UserType } from "../../../stores/useUserStore";
import EnterPinModal from "../../ui/modal/EnterPinModal";
import Spinner from "../../ui/Spinner/Spinner";
import Toast from "../../ui/toast/Toast";
import { autoClearError } from "../../../utils/helpers";
import { MOBILE_LENGTH_BY_ISO2, SupportedISO2 } from "../../../utils/constant";

interface CurrencyData {
  code: string;
  iso2: string;
  symbol: string;
  name: string;
  dialCode?: string;
  currencyCode?: string;
}

interface MobileMoneyWithdrawModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (transaction?: Transaction) => void;
  wallet: Wallet;
  amount: number;
  fee: number;
  preloadedNetworks?: any[];
  currencyData: CurrencyData;
}

const MobileMoneyWithdrawModal = ({
  isOpen,
  onClose,
  wallet,
  amount,
  fee,
  onSuccess,
  preloadedNetworks = [],
  currencyData,
}: MobileMoneyWithdrawModalProps) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [networks, setNetworks] = useState<any[]>(preloadedNetworks);
  const [showPinModal, setShowPinModal] = useState(false);
  
  const [selectedNetwork, setSelectedNetwork] = useState<any>(null);
  const [isNetworkDropdownOpen, setIsNetworkDropdownOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [narration, setNarration] = useState("");
  const [isVerifyingPhone, setIsVerifyingPhone] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);
  
  const networkDropdownRef = useRef<HTMLDivElement>(null);


  // Get phone number length based on ISO2
  const expectedPhoneLength = currencyData?.iso2 && currencyData.iso2 in MOBILE_LENGTH_BY_ISO2
    ? MOBILE_LENGTH_BY_ISO2[currencyData.iso2 as SupportedISO2] : 9;

  // Get dial code
  const dialCode = currencyData.dialCode || "233";

  useEffect(() => {
    if (isOpen) {
      resetForm();
      // If we have preloaded networks, use them
      if (preloadedNetworks.length > 0) {
        setNetworks(preloadedNetworks);
      }
    }
  }, [isOpen, preloadedNetworks]);


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (networkDropdownRef.current && !networkDropdownRef.current.contains(event.target as Node)) {
        setIsNetworkDropdownOpen(false);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Phone verification with debounce
  useEffect(() => {
    if (selectedNetwork && phoneNumber.length === expectedPhoneLength && !phoneVerified && !isVerifyingPhone) {
      const debounceTimer = setTimeout(() => {
        verifyPhoneNumber();
      }, 1000);

      return () => clearTimeout(debounceTimer);
    }
  }, [selectedNetwork, phoneNumber, expectedPhoneLength]);

  const resetForm = () => {
    setSelectedNetwork(null);
    setPhoneNumber("");
    setNarration("");
    setError("");
    setSuccess("");
    setPhoneVerified(false);
    setIsNetworkDropdownOpen(false);
  };

  const handleNetworkSelect = (network: any) => {
    setSelectedNetwork(network);
    setIsNetworkDropdownOpen(false);
    setPhoneVerified(false);
    setPhoneNumber("");
    setError("");
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "");
    const limitedValue = value.slice(0, expectedPhoneLength);
    
    setPhoneNumber(limitedValue);
    
    // Clear verified status when phone number changes
    if (phoneVerified && limitedValue !== phoneNumber) {
      setPhoneVerified(false);
    }
  };

  const verifyPhoneNumber = async () => {
    if (!selectedNetwork || !phoneNumber) return;

    setIsVerifyingPhone(true);
    setError("");

    try {
      // Simple validation - just check length
      if (phoneNumber.length === expectedPhoneLength) {
        setPhoneVerified(true);
      }
    } catch (error: any) {
      setError("Failed to verify phone number");
    } finally {
      setIsVerifyingPhone(false);
    }
  };

  const validateForm = () => {
    if (!selectedNetwork) {
      setError("Please select a mobile network");
      autoClearError(setError);
      return false;
    }
    
    if (!phoneNumber || phoneNumber.length !== expectedPhoneLength) {
      setError(`Please enter a valid ${expectedPhoneLength}-digit phone number`);
      autoClearError(setError);
      return false;
    }
    
    if (!phoneVerified) {
      setError("Please verify the phone number");
      autoClearError(setError);
      return false;
    }
    
    return true;
  };

  const handleContinue = () => {
    if (!validateForm()) return;
    setShowPinModal(true);
  };

  const handlePinVerification = async (pin: string): Promise<boolean> => {
    try {
      const user = cache.get("USER") as UserType | null;
      const token = user?.token;
      
      const validationResponse = await axios.post(
        `${import.meta.env.VITE_BASE_URL}/user/pin/validate`,
        { pin },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (validationResponse.data?.success) {
        // PIN is valid, proceed with withdrawal
        await processMobileMoneyWithdrawal();
        return true;
      } else {
        setError("Invalid PIN. Please try again.");
        autoClearError(setError);
        return false;
      }
    } catch (error: any) {
      setError(error.response?.data?.message || "Failed to verify PIN");
      autoClearError(setError);
      return false;
    }
  };

const processMobileMoneyWithdrawal = async () => {
  setLoading(true);
  setError("");
  setSuccess("");

  try {
    const user = cache.get("USER") as UserType | null;
    const token = user?.token;

    const idempotencyKey = `WITHDRAWAL::MOBILEMONEY::${wallet.name}-${amount}-${phoneNumber}`;
    
    // Format phone number with country code
    const fullPhoneNumber = `+${dialCode}${phoneNumber}`;

    // Create the base payload
    const payload: any = {
      currency: wallet.currency,
      amount: amount,
      narration: narration || `Withdrawal to ${selectedNetwork.name}`,
      phoneNumber: fullPhoneNumber,
      network: selectedNetwork.code || selectedNetwork.name,
    };

    // Add iso2 conditionally
    if (currencyData.currencyCode === "XOF" || currencyData.currencyCode === "XAF") {
      payload.iso2 = currencyData.iso2;
    }
    
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/transaction/transfer/momo`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "idempotencykey": idempotencyKey,
        },
      }
    );

    if (response.data?.success) {
      const transaction = response.data.data as Transaction;
      setSuccess("Withdrawal successful! Money will be sent to your mobile money account.");
      setShowPinModal(false);
      setTimeout(() => {
        onSuccess(transaction);
      }, 3000);
    } else {
      throw new Error(response.data?.message || "Withdrawal failed");
    }
  } catch (err: any) {
    setError(err.response?.data?.message || "Failed to process withdrawal");
    setSuccess("");
  } finally {
    setLoading(false);
  }
};

  const formatPhoneNumber = (phone: string): string => {
    if (phone.length <= 3) return phone;
    if (phone.length <= 6) return `${phone.slice(0, 3)} ${phone.slice(3)}`;
    return `${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6)}`;
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        className="max-w-md rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-gray-900"
      >
        <div className="mb-6">
          <div className="flex items-center justify-between">
            <button
              onClick={onClose}
              className="rounded-lg p-1 hover:bg-gray-100 dark:hover:bg-gray-800"
              disabled={loading}
            >
              <X className="h-5 w-5 text-gray-500 dark:text-gray-400" />
            </button>
          </div>

          {success && (
            <div className="mb-4">
              <Toast
                variant="success"
                title={success}
                message="Your account has been debited"
              />
            </div>
          )}
          
          <div className="mt-4 rounded-lg bg-gray-50 p-4 dark:bg-gray-800">
            <div className="text-sm text-gray-500 dark:text-gray-400">
              <p>Mobile Money Withdrawal to {currencyData.name}</p>
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white">
              {wallet.symbol} {amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
            </div>
            <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Fee: {wallet.symbol} {fee.toFixed(2)}
            </div>
          </div>
        </div>

        {error && !showPinModal && (
          <div className="mb-4">
            <Alert variant="error" title="Error" message={error} />
          </div>
        )}

        <div className="space-y-6">
          {/* Network Provider Selection */}
          <div className="relative" ref={networkDropdownRef}>
            <label className="mb-2 flex items-center gap-1 text-sm font-medium text-gray-700 dark:text-gray-300">
              <Wifi className="h-4 w-4" />
              Mobile Network Provider
            </label>
            
            <div className="relative">
              <button
                type="button"
                onClick={() => setIsNetworkDropdownOpen(!isNetworkDropdownOpen)}
                disabled={loading}
                className={`flex w-full items-center justify-between rounded-lg border px-4 py-3 text-left transition-colors ${
                  selectedNetwork
                    ? "border-primary bg-primary/5 dark:border-primary dark:bg-primary/10"
                    : "border-gray-200 bg-gray-50 hover:border-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:hover:border-gray-600"
                }`}
              >
                <div className="flex items-center gap-3">
                  {selectedNetwork ? (
                    <>
                      {selectedNetwork.logo && (
                        <img
                          src={selectedNetwork.logo}
                          alt={selectedNetwork.name}
                          className="h-6 w-6 object-contain"
                        />
                      )}
                      <span className="font-medium text-gray-900 dark:text-white">
                        {selectedNetwork.name}
                      </span>
                    </>
                  ) : (
                    <span className="text-gray-500 dark:text-gray-400">
                      Select a mobile network
                    </span>
                  )}
                </div>
                <ChevronDown
                  className={`h-5 w-5 text-gray-400 transition-transform ${
                    isNetworkDropdownOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {isNetworkDropdownOpen && networks.length > 0 && (
                <div className="absolute z-10 mt-1 w-full rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800">
                  <div className="max-h-60 overflow-auto py-1">
                    {networks.map((network) => (
                      <button
                        key={network.code}
                        type="button"
                        onClick={() => handleNetworkSelect(network)}
                        className={`flex w-full items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-700 ${
                          selectedNetwork?.code === network.code
                            ? "bg-gray-100 dark:bg-gray-700"
                            : ""
                        }`}
                      >
                        {network.logo && (
                          <img
                            src={network.logo}
                            alt={network.name}
                            className="h-5 w-5 object-contain"
                          />
                        )}
                        <span className="font-medium text-gray-900 dark:text-white">
                          {network.name}
                        </span>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            
            {selectedNetwork && (
              <div className="mt-2 flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400">
                <Wifi className="h-3 w-3" />
                <span>Selected network: {selectedNetwork.name}</span>
              </div>
            )}
          </div>

          {/* Phone Number */}
          <div>
            <label className="mb-2 flex items-center gap-1 text-sm font-medium text-gray-700 dark:text-gray-300">
              <Phone className="h-4 w-4" />
              Mobile Money Number
            </label>
            <div className="relative">
              <div className="absolute left-3 top-1/2 flex -translate-y-1/2 items-center">
                <span className="text-gray-500 dark:text-gray-400">+{dialCode}</span>
              </div>
              <input
                type="tel"
                value={phoneNumber}
                onChange={handlePhoneChange}
                className="w-full rounded-lg border border-gray-200 bg-gray-50 pl-16 pr-10 py-3 text-gray-700 transition-colors focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white disabled:opacity-50"
                placeholder={`Enter ${expectedPhoneLength}-digit number`}
                disabled={loading || !selectedNetwork}
                maxLength={expectedPhoneLength}
                inputMode="numeric"
                pattern="[0-9]*"
              />
              
              <div className="absolute right-3 top-1/2 -translate-y-1/2">
                {isVerifyingPhone ? (
                  <Spinner className="h-4 w-4 text-primary" />
                ) : phoneVerified ? (
                  <CheckCircle className="h-4 w-4 text-green-500" />
                ) : null}
              </div>
            </div>
            
            <div className="mt-2 flex flex-col gap-1">
              <div className="text-xs text-gray-500 dark:text-gray-400">
                {`Enter your ${expectedPhoneLength}-digit number (without +${dialCode} prefix)`}
              </div>
              {phoneNumber && (
                <div className="text-xs font-medium text-gray-700 dark:text-gray-300">
                  Complete number: +{dialCode} {formatPhoneNumber(phoneNumber)}
                </div>
              )}
            </div>
          </div>

          {/* Narration */}
          <div>
            <label className="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Narration (Optional)
            </label>
            <input
              type="text"
              value={narration}
              onChange={(e) => setNarration(e.target.value)}
              className="w-full rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-gray-700 transition-colors focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white disabled:opacity-50"
              placeholder="e.g., Withdrawal for personal use"
              maxLength={100}
              disabled={loading}
            />
            <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              {narration.length}/100 characters
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-100 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700"
          >
            Cancel
          </button>
          
          <button
            onClick={handleContinue}
            disabled={loading || !selectedNetwork || !phoneNumber || phoneNumber.length !== expectedPhoneLength}
            className="rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-100 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700"
          >
            {loading ? "Processing..." : "Continue"}
          </button>
        </div>
      </Modal>

      {/* Separate PIN Modal */}
      <EnterPinModal
        isOpen={showPinModal}
        onClose={() => setShowPinModal(false)}
        onPinVerified={handlePinVerification}
        title="Confirm Mobile Money Withdrawal"
        description="Enter your 4-digit PIN to complete this withdrawal"
        showForgotPin={true}
      />
    </>
  );
};

export default MobileMoneyWithdrawModal;